import { DIRECTIVE_NAME as GRID_DETAILS_DIRECTIVE_NAME, GridDetailsDirective } from './grid-details.directive'
import { GRID_DETAILS_SERVICES_MODULE_NAME } from './services'

export const GRID_DETAILS_MODULE_NAME = 'simax.common.grid-details'

const module = angular.module(GRID_DETAILS_MODULE_NAME,
    [
        GRID_DETAILS_SERVICES_MODULE_NAME
    ])

console.log(GRID_DETAILS_SERVICES_MODULE_NAME)

module.directive(GRID_DETAILS_DIRECTIVE_NAME, [() => new GridDetailsDirective()])